import {
  StaticDatePicker,
  StaticDatePickerProps,
} from "@mui/x-date-pickers/StaticDatePicker/StaticDatePicker";

export type { StaticDatePickerProps };
export default StaticDatePicker;
